/*
 * @Author: YuanYuan
 * @Date: 2024-02-23 16:14:40
 * @LastEditTime: 2025-12-18 10:15:57
 * @Description: 网站接入路由定义
 */
import i18n from '@/i18n'
import { goWebsiteIndex } from '@/views/website/func'

const Meta = {
  leftMenuCode: 'Configurations',
  leftActiveIndex: '/websiteSettings'
}

export default [
  {
    path: '/websiteSettings',
    meta: {
      ...Meta,
      title: i18n.t('menu.webAccess')
    },
    component: () => import('@/views/website/index.vue')
  },
  // 新增域名接入
  {
    path: '/websiteSettings/add',
    meta: {
      ...Meta,
      title: i18n.t('website.createDomain'),
      backable: () => goWebsiteIndex(),
      noScrollbar: true
    },
    component: () => import('@/views/website/add.vue')
  },
  // https配置
  {
    path: '/websiteSettings/https',
    meta: {
      ...Meta,
      title: i18n.t('website.httpsConfig'),
      backable: () => goWebsiteIndex()
    },
    component: () => import('@/views/website/https.vue')
  },
  // 区域变更
  {
    path: '/websiteSettings/region',
    meta: {
      ...Meta,
      title: i18n.t('website.regionChange'),
      backable: () => goWebsiteIndex()
    },
    component: () => import('@/views/website/region.vue')
  },
  // 换源
  {
    path: '/websiteSettings/origin',
    meta: {
      ...Meta,
      title: i18n.t('website.changeOrigin'),
      backable: () => goWebsiteIndex()
    },
    component: () => import('@/views/website/origin.vue')
  },
  {
    path: '/websiteSettings/config',
    meta: {
      ...Meta,
      title: i18n.t('website.modifyAcceConfig'),
      backable: () => goWebsiteIndex(),
      noScrollbar: true
    },
    component: () => import('@/views/website/config.vue')
  }
]
